import React from 'react';

interface Props {
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}

const roundedClasses: Record<NonNullable<Props['rounded']>, string> = {
  sm: 'rounded',
  md: 'rounded-lg',
  lg: 'rounded-xl',
  full: 'rounded-full',
};

export function Skeleton({ className = '', rounded = 'md' }: Props) {
  return (
    <div
      className={`animate-pulse bg-gray-200 ${roundedClasses[rounded]} ${className}`}
    />
  );
}

export function SkeletonCard() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 space-y-3">
      <div className="flex items-start gap-3">
        <div className="flex-1 space-y-2">
          <Skeleton className="h-5 w-3/4" rounded="md" />
          <Skeleton className="h-4 w-1/2" rounded="md" />
        </div>
        <Skeleton className="h-6 w-16" rounded="full" />
      </div>
      <div className="flex gap-2">
        <Skeleton className="h-5 w-20" rounded="full" />
        <Skeleton className="h-5 w-16" rounded="full" />
      </div>
    </div>
  );
}

export function SkeletonList({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonText({ lines = 3, className = '' }: { lines?: number; className?: string }) {
  return (
    <div className={`space-y-2 ${className}`}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={`h-4 ${i === lines - 1 ? 'w-2/3' : 'w-full'}`}
          rounded="md"
        />
      ))}
    </div>
  );
}
